import { ContextManager } from '../context/manager';
import { PageSettingsManager } from '../page/settings';
import { SavedViewVersion } from './useSavedView';

export const createViewStateFn = () => {
  const contextManager = ContextManager.getInstance();
  const context = contextManager.get();

  const filterValues = context.filters?.values || {};
  const settingValues = context.settings?.values;
  const pageSettings = PageSettingsManager.getInstance().get();

  return {
    version: SavedViewVersion.v1,
    filterValues,
    settingValues,
    pageSettings,
  };
};
